import React from 'react';
import { GlobeIcon, MailIcon, PersonStandingIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-violet-100 bg-white px-4 py-12" data-id="element-175" data-mp="3ggarzyv0aj71">
      <div className="mx-auto max-w-4xl text-center" data-id="element-176" data-mp="32o4deh7i4k9p">
        <p className="inline-flex items-center gap-2 font-display text-lg font-bold text-primary" data-id="element-177" data-mp="32pp6s3i2xx5z">
          <PersonStandingIcon className="h-5 w-5 text-rose" data-id="element-178" data-mp="36ppkflxcu4bz" /> COMPRA DIGITAL YA™
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-179" data-mp="3ufju5umdncs0">
          El sistema N°1 de movilidad y flexibilidad para Argentina.
        </p>
        <p className="mt-2 text-sm font-medium text-slate-500" data-id="element-180" data-mp="3lecaahklyehg">
          Porque moverte mejor merece tener un sistema real.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-medium text-slate-600 sm:flex-row sm:gap-6" data-id="element-181" data-mp="3qcnh0jflw8vg">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 hover:text-accent" href="mailto:compradigitalyaa@gmail.com" data-id="element-182" data-mp="29xvrce9uhfpu">
            <MailIcon className="h-4 w-4" data-id="element-183" data-mp="3la2a6wqof7wa" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 hover:text-accent" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-184" data-mp="3gbimaqsivm1a">
            <GlobeIcon className="h-4 w-4" data-id="element-185" data-mp="3qazqf3s4lrv5" /> www.compradigitalya.com
          </a>
        </div>
        <p className="mt-7 border-t border-violet-100 pt-6 text-xs font-medium text-slate-400" data-id="element-186" data-mp="80nrednpyga8">
          © Compra Digital Ya™ 2026 — Todos los derechos reservados.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-xs font-medium leading-relaxed text-slate-400" data-id="element-187" data-mp="hs1yb6i02ide">
          Este material es de uso personal. No es un tratamiento médico ni reemplaza la consulta con
          un profesional de la salud.
        </p>
      </div>
    </footer>;
}